var _rect, _rect2, _g, _rect3, _g2, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContrast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 77.3333,
    height: 80,
    rx: 6,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_49",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 38,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6676,
    y: 80,
    width: 80,
    height: 37,
    transform: "rotate(-90 40.6676 80)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_49)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8261 14.501C42.6711 14.538 44.34 15.6058 45.1477 17.266L62.3372 52.5959C63.1013 54.1664 62.9759 56.0245 62.0075 57.4779C58.1676 63.2414 51.4731 66.1127 45.0559 65.3904C38.3818 64.6391 32.3747 60.0696 29.9742 51.9629C29.7977 51.367 29.7394 50.7642 29.7854 50.1796L25.0809 58.9377C23.7954 61.3307 20.8145 62.228 18.4229 60.9417C16.0313 59.6554 15.1346 56.6727 16.4201 54.2796L36.3971 17.0903C37.2708 15.4639 38.9811 14.4639 40.8261 14.501ZM31.6616 46.6869C32.1338 46.3177 32.6819 46.0294 33.2913 45.8487C35.8946 45.0769 38.6303 46.5629 39.4016 49.1679C40.7178 53.6125 43.5377 55.3188 46.1552 55.6134C48.2083 55.8445 50.357 55.241 52.0496 53.9282L40.511 30.2128L31.6616 46.6869Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1007_49",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 80
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 80,
    width: 80,
    height: 40,
    transform: "rotate(-90 0.666748 80)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1007_49)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8261 14.501C42.6711 14.538 44.34 15.6058 45.1477 17.266L62.3372 52.5959C63.1013 54.1664 62.9759 56.0245 62.0075 57.4779C58.1676 63.2414 51.4731 66.1127 45.0559 65.3904C38.3818 64.6391 32.3747 60.0696 29.9742 51.9629C29.7977 51.367 29.7394 50.7642 29.7854 50.1796L25.0809 58.9377C23.7954 61.3307 20.8145 62.228 18.4229 60.9417C16.0313 59.6554 15.1346 56.6727 16.4201 54.2796L36.3971 17.0903C37.2708 15.4639 38.9811 14.4639 40.8261 14.501ZM31.6616 46.6869C32.1338 46.3177 32.6819 46.0294 33.2913 45.8487C35.8946 45.0769 38.6303 46.5629 39.4016 49.1679C40.7178 53.6125 43.5377 55.3188 46.1552 55.6134C48.2083 55.8445 50.357 55.241 52.0496 53.9282L40.511 30.2128L31.6616 46.6869Z",
    fill: "#C2C2C2"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.8333,
    y1: -2.18557e-8,
    x2: 40.8333,
    y2: 80,
    stroke: "url(#paint0_linear_1007_49)",
    strokeOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1007_49",
    x1: 40.3333,
    y1: 80,
    x2: 40.3333,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.31f7871217affae33cb5b8030dc11b6e.svg";
export { ForwardRef as ReactComponent };